/**
 * Sanitizes upload file names consistently with backend multer.
 * @param {string} fileName
 * @returns {string}
 */
export function sanitizeUploadFileName(fileName) {
    return String(fileName)
        .replace(/\s+/g, '_')
        .replace(/[^a-zA-Z0-9._-]/g, '');
}

export default sanitizeUploadFileName;
